__turbopack_context__.v({
  "breadcrumbs": "_04Ry7G_breadcrumbs",
  "breadcrumbsCurrent": "_04Ry7G_breadcrumbsCurrent",
  "breadcrumbsItem": "_04Ry7G_breadcrumbsItem",
  "breadcrumbsLink": "_04Ry7G_breadcrumbsLink",
  "breadcrumbsList": "_04Ry7G_breadcrumbsList",
  "breadcrumbsSep": "_04Ry7G_breadcrumbsSep",
});
